export default "__VITE_ASSET__BE8lE0qT__"